import moment from 'moment';

export function convertObjToDate(obj) {
    return new Date(
        (obj && obj.y ? obj.y : 1970),
        (obj && obj.m ? obj.m : 0),
        (obj && obj.d ? obj.d : 1),
        (obj && obj.h ? obj.h : 0),
        (obj && obj.min ? obj.min : 0));
}

export function convertDateToJSON(date) {
    if (date) { // if date exists
        var myJSON = {};
        myJSON.y = date.getFullYear();
        myJSON.m = date.getMonth();
        myJSON.d = date.getDate();
        myJSON.h = date.getHours();
        myJSON.min = date.getMinutes();
        return myJSON;
    } else
        return {};
}



export function sortArrayByDate(arr, dateProperty, descending) { //TODO not checking if both are of type Dates
    return arr.sort(function(a,b){
        let dateA = a[dateProperty];
        let dateB = b[dateProperty];
        if (!(dateA)) {
            return descending;
        }
        if (!(dateB)) {
            return !descending;
        }
        return (descending ? dateB - dateA : dateA - dateB);
    })
}

export function formatDate(date){
    return moment(date).format("MMMM Do YYYY");
}

export function formatISODate(date){
    return moment(date.iso, 'YYYY-MM-DDTHH:mm:ss').format("MMM Do YYYY");
}

export function formatDateForFileName(date){
    return moment(date).format("DDMMMYYYY");
}

export function formatDateWithTime(date){
    return moment(date).format("MMM Do h:mm A");
}

export function formatDateOnlyTime(date){
    return moment(date).format("h:mm A");
}

export function addHourLabelForDescription(dateType){
    return (dateType.getHours() > 12 ? 'p.m.' : 'a.m.');
}

export function convertMinutesInto2CharString(dateType){
    let minutes = dateType.getMinutes();
    return (minutes < 10 ? '0' : '') + minutes;
}

export function convertHoursFromMilitaryTime(dateType){
    let hours = dateType.getHours();
    return (hours > 12 ? hours-12 : hours);
}



export function getSafeEventDate(date){
    let safeDate;
    try{
        safeDate = convertObjToDate( JSON.parse(date) );
    }
    catch(exec){
        // in case the date is null/undefined so it won't crash - set the date for tommorrow
        // TODO: add a server call sending mail there is a problem with the event date
        safeDate = new Date();
        safeDate.setDate(safeDate.getDate() + 1);
    }
    return safeDate;
}



// WEBPACK FOOTER //
// ./src/utils/dateTimeUtils.js